import './App.css';
import {BrowserRouter as Router,Route, Routes } from 'react-router-dom';
import Header from './Header';
import ReactDOM from 'react-dom';

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

import Chatbot from './components/chatbot/Chatbot';

const App = () => {
  return (
    <div className="App">
 
<Router>
  <Chatbot/>
</Router>

    </div>
  );
}


// Find the root element where you want to mount the React app
const rootElement = document.getElementById('ash_chatbot');
if (rootElement) {
    const root = ReactDOM.createRoot(rootElement); // Create a root
    root.render(<App />); // Render the app
}

export default App;
